module.exports = __webpack_public_path__ + "media/images/menu/grus-8da09d1882e81cc70b6b22238793e27f.jpg";